import React from 'react';
import './App.css';

function App() {
  const handleEmailClick = () => {
    const email = 'info@nexapromos.com';
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Terms of Service Agreement
          </h1>
          
          <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
            <p className="font-medium italic">
              Please read these Terms and Conditions (“Agreement,” “Terms”) carefully before using any website, landing page, or digital property operated by Nexa Nova Media LLC (“Company,” “we,” “us,” or “our”).
            </p>

            <p>
              This Agreement applies to all websites, promotional pages, affiliate websites, marketing funnels, and online services operated or controlled by Nexa Nova Media LLC (collectively, the “Sites”).
            </p>

            <p>
              By accessing or using any of the Sites in any manner, including but not limited to visiting, browsing, submitting information, or clicking affiliate links, you agree to be bound by these Terms. If you do not agree, you must discontinue use of the Sites immediately.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Intellectual Property
            </h2>
            <p>
              All content, features, and functionality available on the Sites, including but not limited to text, graphics, logos, images, videos, and software, are the property of Nexa Nova Media LLC or its content licensors and are protected by applicable intellectual property laws.
            </p>
            <p>
              You may not reproduce, distribute, modify, or exploit any content without our prior written consent.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Affiliate Disclosure & Third-Party Offers
            </h2>
            <p>
              The Sites may contain links to third-party products, services, or websites. Some of these links may be affiliate links, meaning we may earn a commission at no additional cost to you if you choose to make a purchase.
            </p>
            <p>
              We do not own, control, or guarantee any third-party products, services, claims, or representations. Any interaction, purchase, or transaction you engage in with a third party is solely between you and that third party.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              No Guarantees / No Professional Advice
            </h2>
            <p>
              The information provided on the Sites is for general informational and marketing purposes only.
            </p>
            <p>
              We make no representations or warranties regarding results, earnings, health outcomes, financial success, or any other specific outcomes. Nothing on the Sites should be considered professional, legal, financial, medical, or business advice.
            </p>
            <p>
              You are solely responsible for your decisions and actions.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Limitation of Liability
            </h2>
            <p>
              To the maximum extent permitted by law, Nexa Nova Media LLC shall not be liable for any direct, indirect, incidental, consequential, special, or punitive damages arising out of or related to your use of the Sites, third-party offers, or reliance on any information provided.
            </p>
            <p>
              Your sole remedy for dissatisfaction with the Sites is to discontinue use.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Indemnification
            </h2>
            <p>
              You agree to indemnify and hold harmless Nexa Nova Media LLC, its members, managers, affiliates, and partners from any claims, damages, losses, liabilities, or expenses arising from your use of the Sites or violation of this Agreement.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Termination
            </h2>
            <p>
              We reserve the right, at our sole discretion, to suspend or terminate access to any Site at any time, without notice, for any reason.
            </p>
            <p>
              All provisions that by their nature should survive termination shall survive, including intellectual property, disclaimers, limitation of liability, and indemnification.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Links to Other Websites
            </h2>
            <p>
              The Sites may contain links to third-party websites that are not owned or controlled by us. We are not responsible for the content, policies, or practices of any third-party sites.
            </p>
            <p>
              We encourage you to review the terms and privacy policies of any third-party websites you visit.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Governing Law
            </h2>
            <p>
              This Agreement shall be governed and construed in accordance with the laws of the state in which Nexa Nova Media LLC is registered, without regard to conflict of law principles.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Changes to These Terms
            </h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting. Your continued use of the Sites constitutes acceptance of the updated Terms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Contact Information
            </h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 space-y-2">
              <p><strong>Company:</strong> Nexa Nova Media LLC</p>
              <p>
                <strong>Email:</strong>{' '}
                <button
                  onClick={handleEmailClick}
                  className="text-blue-600 hover:text-blue-800 underline cursor-pointer bg-transparent border-none p-0 font-inherit"
                  aria-label="Contact us via email"
                >
                  info [at] nexapromos [dot] com
                </button>
              </p>
            </div>

            <div className="mt-12 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500 text-center">
                Last Updated: January 24, 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;